import {reactive} from 'vue'

export const browserData = reactive({
	"browser": "",
	"engine": "",
	"os": "",
	"platform": "",
	"userAgent": ""
})